import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import parse from 'html-react-parser';

import moment from 'moment-timezone';

import Swal from 'sweetalert2';

import { Status, } from '../../classess/status/status';
import { Customer, } from '../../classess/customer/customer';
import { BackupReview, } from '../../classess/backupReview/backupReview';
import { DigitizedDocument } from '../../classess/main/digitizedDocument';
import { BackupReviewDetail } from '../../classess/backupReview/backupReviewDetail';

import { GlobalFormats } from '../../classess/main/globalFormats';

import BackupReviewReport from './BackupReviewReport';
import ServiceDocumentDetail from './ServiceDocumentDetails';
import BackupReviewDetailAddEditDetail from './BackupReviewDetailAddEditDetail';

import {
    badgetStatusGeneric, getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNull, isUndNullEmp, isValidDate, getLanguageObj,
    getResponse, getRolesType, handleResponseMessageAsync, settings, styles, getUserRoles,
    LoadingSection, awaitDelayAsync
} from '../../helpers/main';
import { BackupReviewService } from '../../services/backupReviews/BackupReviewService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { SwalPropertiesClass } from '../../classess/main/notifications/swalProperties';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'BackupReviewEdit';

export default function BackupReviewEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const { type = '', id = '' } = useParams();
    const [viewType] = useState(type === labels?.edit?.en?.toLowerCase() ?
        1 :
        (type === labels?.details?.en?.toLowerCase() ? 2 : 0));

    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const isMount = useRef(true);
    const dtBackupReviewDetailsId = 'dtBackupReviewDetails';
    const dtInformationDocumentsId = 'dtInformationDocuments';
    const dtServiceDocumentsId = 'dtServiceDocuments';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        delete: false,
        edit: false,
        addDetails: false,
        back: false,
        report: false,
        serviceDocumentDetail: false,
    });
    const brdFieldViewsObj = {
        status: {
            label: '',
            badget: '',
        },
        scheduledDate: {
            date: '',
            time: ''
        },
        executionDate: {
            date: '',
            time: ''
        },
        commentary: '',
    };
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        reportShowModal: false,
        languageObj: languageObj,
        dtBackupReviewDetailsId: dtBackupReviewDetailsId,
        dtBackupReviewDetailsRowId: 0,
        dtInformationDocumentsId: dtInformationDocumentsId,
        dtDigitizedDocumentsRowId: 0,
        dtServiceDocumentsId: dtServiceDocumentsId,
        dtServiceDocumentsRowId: 0,
        backupReview: BackupReview?.getClass({}, false),
        backupReviewDetail: BackupReviewDetail?.getClass({}, false),
        brdFieldViews: brdFieldViewsObj,
        serviceDocument: DigitizedDocument?.getClass({}, false),
        sdShowModal: false,
        status: [Status?.getClass({}, false)],
        userRoles: userRoles,
        window: window,
    });
    const controls = {
        buttons: {
            addDetail: {
                defaultClass: 'btn btn-info shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddBackupReview',
            },
            back: {
                defaultClass: 'btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary',
                id: 'btnBack',
            },
            delete: {
                defaultClass: 'btn btn-danger shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnDelete',
            },
            edit: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnEdit',
            },
            report: {
                defaultClass: 'btn btn-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnReport',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
            sdDetail: {
                defaultClass: 'btn btn-info shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSdDetail',
            },
        },
        checkBoxs: {
            isActive: {
                id: 'chkIsActive',
                defaultClass: '',
            },
        },
        dataTables: {
            backupReviews: {
                inputs: {
                    search: {
                        id: `${dtBackupReviewDetailsId}_filter input`,
                        defaultClass: 'form-control form-control-sm bg-light border-0 shadow-sm ml-2',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtBackupReviewDetailsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtBackupReviewDetailsId}_paginate`,
                        defaultClass: '',
                    },
                },
                columns: {
                    process: {
                        id: 5,
                    },
                },
            },
            serviceDocuments: {
                inputs: {
                    search: {
                        id: `${dtServiceDocumentsId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtServiceDocumentsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtServiceDocumentsId}_paginate`,
                        defaultClass: '',
                    },
                },
                columns: {
                    process: {
                        id: 8,
                    },
                },
            },
        },
        icons: {
            addDetail: {
                id: 'iconAddDetail',
                defaultClass: icons?.fasFa?.list,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
            delete: {
                id: 'iconDelete',
                defaultClass: icons?.fasFa?.trash,
            },
            edit: {
                id: 'iconEdit',
                defaultClass: icons?.fasFa?.edit,
            },
            report: {
                id: 'iconReport',
                defaultClass: icons?.fasFa?.fileAlt,
            },
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
            sdDetail: {
                id: 'iconSdDetail',
                defaultClass: icons?.fasFa?.list,
            },
        },
        inputs: {
            number: {
                id: 'inpuntNumber',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
                //defaultClass: 'form-control',
            },
            dateBegin: {
                id: 'inputDateBegin',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
                //defaultClass: 'form-control text-black bg-transparent datetimepicker-input',
            },
        },
        pickers: {
            dateBegin: {
                id: 'pkRegisterDate',
            },
        },
        selects: {
            customers: {
                id: 'selCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            addDetail: {
                id: 'spAddDetail',
                defaultClass: '',
            },
            back: {
                id: 'spBack',
                defaultClass: '',
            },
            delete: {
                id: 'spDelete',
                defaultClass: '',
            },
            edit: {
                id: 'spEdit',
                defaultClass: '',
            },
            report: {
                id: 'spReport',
                defaultClass: '',
            },
            save: {
                id: 'spSave',
                defaultClass: '',
            },
            sdDetail: {
                id: 'spSdDetail',
                defaultClass: '',
            },
        },
        textAreas: {
            commentary: {
                id: 'txtAreaCommentary',
                //defaultClass: 'form-control text-black bg-transparent',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            }
        }
    };
    const urls = {
        back: `${backend?.urls?.backupReviews}/`,
        edit: `${backend?.urls?.backupReviews}/${labels?.edit?.en?.toLowerCase()}/`,
        notFound: `${backend?.urls?.notFound}`,
    };
    const [customers, setCustomers] = useState([Customer?.getClass({}, false)]);
    const [customer, setCustomer] = useState(Customer?.getClass({}, false));
    const [status, setStatus] = useState([Status?.getClass({}, false)]);
    const [backupReview, setBackupReview] = useState(BackupReview?.getClass({}, false));
    const [dataInfo, setDataInfo] = useState({ id: 0, description: '', rowId: 0, type: 0, });
    const [backupReviewBefore, setBackupReviewBefore] = useState(BackupReview?.getClass({}, false));
    const [serviceDocuments, setServiceDocuments] = useState([DigitizedDocument?.getClass({}, false)]);
    const rFieldsViewObj = {
        backupReview: {
            commentary: '',
            customer: '',
            dateBegin: '',
            id: 0,
            isActive: false,
            register: '',
        },
    };
    const [rFieldsView, setRFieldsView] = useState(rFieldsViewObj);
    const [errors, setErrors] = useState({
        customer: '',
        dateBegin: '',
        commentary: '',
    });
    const [dataFormLength] = useState(BackupReview.minMaxLength(false));
    const btnSdDetailRef = useRef(null);
    //#endregion methods

    //#region methods
    //#region backupreview
    const addEditBackupReview = async ({
        e = {},
        subMethod = '', } = {}
    ) => {
        const currentMethod = 'addEditBackupReview';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let statusData = [Status?.getClass({}, false)];
            let customerData = Customer?.getClass({}, false);
            let customersData = [Customer?.getClass({}, false)];
            let backupReviewData = BackupReview?.getClass({}, false);
            let serviceDocumentsData = [DigitizedDocument?.getClass({}, false)];
            let digitizedDocumentsData = [DigitizedDocument?.getClass({}, false)];
            let backupReviewDetailsData = [BackupReviewDetail?.getClass({}, false)];
            //#endregion variables

            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region add / edit (data)
            if ((backupReview?.id || 0) <= 0) {
                response = await BackupReviewService.create({
                    auth,
                    backupReview,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            } else {
                response = await BackupReviewService.update({
                    auth,
                    backupReview,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }

            if (!response?.isSuccess || response?.isWarning) return;

            //#region set data
            customersData = response?.result?.customers?.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            setCustomers(customersData);
            customerData = response?.result?.customer || {};

            setCustomer(customerData);
            backupReviewData = response?.result?.backupReview || {};
            if (backupReviewData?.id <= 0) {
                const dateTimeFormat = `${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f1}`;//'YYYY-MM-DDTHH:mm';
                const today = new Date()?.toISOString();
                backupReviewData.dateBegin = moment(today).format(dateTimeFormat);
            }
            setBackupReview(backupReviewData);
            setBackupReviewBefore(backupReviewData);
            backupReviewDetailsData = response?.result?.backupReviewDetails || [];
            statusData = response?.result?.status || [];
            setStatus(statusData);
            digitizedDocumentsData = response?.result?.digitizedDocuments || [];
            serviceDocumentsData = response?.result?.serviceDocuments || [];
            setServiceDocuments(serviceDocumentsData);
            //#endregion set data
            //#endregion add / edit (data)

            $(`#${dtInformationDocumentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            $(`#${dtServiceDocumentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            $(`#${dtBackupReviewDetailsId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            //#region set datatable
            if ((!isUndNullEmp({ data: backupReviewDetailsData, subMethod: currentMethod })?.result && backupReviewDetailsData.length > 0) ||
                (!isUndNullEmp({ data: digitizedDocumentsData, subMethod: currentMethod })?.result && digitizedDocumentsData.length > 0)) {
                response = setDataInDataTable({
                    data: backupReviewDetailsData,
                    digitizedDocuments: digitizedDocumentsData,
                    serviceDocuments: serviceDocumentsData,
                    status: statusData,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion set datatable

            response = getResponse({
                type: 0,
                msgText: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getBackupReviewReport = async ({
        e = {},
        subMethod = '', } = {}
    ) => {
        const currentMethod = 'getBackupReviewReport';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, report: true, showLoading: true }));

            //#region get data (backupreview report)
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            setModalObj(prev => ({
                ...prev,
                backupReviewDetail: {
                    ...BackupReviewDetail?.getClass({}, false),
                    backupReviewId: backupReviewBefore?.id,
                    scheduledDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                    executionDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                },
                reportShowModal: true,
                type: 0,
            }));
            //#endregion get data (backupreview report)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, report: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteBackupReview = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        subMethod = '', } = {}
    ) => {
        const currentMethod = 'deleteBackupReview';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let backupReviewData = BackupReview?.getClass({}, false);
            //#endregion variables

            e?.preventDefault?.();

            //#region check data
            if (id <= 0) {
                response = getResponse({
                    type: -1,
                    msgText: `<b>id</b> - ${messages?.itIsRequired?.[languageObj?.id]}<br/>`
                });
                return;
            }
            //#endregion check data

            //#region show message
            const msgTextObj = {
                one: messages?.areYouShureDeleteThis?.[languageObj?.id],
                two: `${labels?.backupReview?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            let swalProperties = new SwalPropertiesClass().getClass();
            swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                backdrop: true,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data(backupreview)
                        preConfirmResponse = await BackupReviewService.deleteAsync({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (backupreview)

                        //#region backup review (set new data)
                        const dateTimeFormat = `${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f1}`;//'YYYY-MM-DDTHH:mm';
                        const today = new Date()?.toISOString();

                        backupReviewData = {
                            ...backupReviewData,
                            customerId: customer?.id,
                            dateBegin: moment(today).format(dateTimeFormat),
                            register: moment(today).format(dateTimeFormat),
                        };

                        setBackupReview(backupReviewData);
                        //#endregion backup review (set new data)

                        //#region set data input timers
                        preConfirmResponse = setDateInControl({
                            _date: new Date().toISOString(),
                            _dateBegin: backupReviewData?.dateBegin,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion set data input timers

                        //#region delete datatable (backupreview)
                        $(`#${dtBackupReviewDetailsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        //#endregion delete datatable (backupreview)

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: messages?.processCompletedSuccessfully?.[languageObj?.id]
                        });
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion backupreview

    //#region backupreviewdetails
    const getAddBackupReviewDetail = async ({
        e = {},
        subMethod = '' } = {}
    ) => {
        const currentMethod = 'getAddBackupReviewDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region check role
            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`
                });
                return;
            }
            //#endregion check role

            //#region check data
            if ((backupReview?.id || 0) <= 0) {
                response = getResponse({
                    type: 1,
                    msgText: `<b>id</b>: ${messages?.itIsRequired?.[languageObj?.id]}.`
                });
                return;
            }
            //#endregion check data

            setProcess(prev => ({ ...prev, addDetails: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            //#region set data
            setModalObj(prev => ({
                ...prev,
                backupReview: backupReview,
                backupReviewDetail: BackupReviewDetail?.getClass({
                    backupReviewId: backupReview?.id,
                    scheduledDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                    executionDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                    register: new Date().toISOString(),
                }, false),
                status: status,
                showModal: true,
                type: 0,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, addDetails: false, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getEditBackupReviewDetail = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        type = 1,
        subMethod = '' } = {}
    ) => {
        const currentMethod = 'getEditBackupReviewDetail';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const brdFieldViews = brdFieldViewsObj;
            let statusData = [Status?.getClass({}, false)];
            let backupReviewDetailData = BackupReviewDetail?.getClass({}, false);
            //#endregion variables

            e?.preventDefault?.();

            //#region check role
            if (userRoles?.isAnonymous) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`
                });
                return;
            }
            //#endregion check role

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region backupreviewdetail (get byid)
            response = await BackupReviewService.getDetailById({
                auth,
                id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            statusData = response?.result?.status || [];
            setStatus(statusData);
            backupReviewDetailData = response?.result?.backupReviewDetail || {};
            //#endregion backupreviewdetail (get byid)

            //#region check data
            if (isUndNullEmp({ data: backupReviewDetailData, subMethod: currentMethod })?.result) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/><b>${description}</b><br/>`
                });
                return;
            }
            //#endregion check data

            //#region backupreviewdetail (set fieldviews)
            if (type === 2) {
                //#region variables
                let statusObj = {
                    model: Status?.getClass(statusData?.filter(({ id, }) => id === backupReviewDetailData?.statusId)[0], false),
                    label: '',
                    badget: '',
                };
                statusObj.label = !isUndNullEmp({ data: statusObj?.model?.label, subMethod: currentMethod, })?.result ?
                    statusObj?.model?.label : `${statusObj?.model?.name?.replaceAll(' ', '')?.charAt(0)?.toLowerCase()}${statusObj?.model?.name?.replaceAll(' ', '')?.slice(1)}`
                statusObj.badget = badgetStatusGeneric({
                    type: (statusObj?.model?.id || 5) === 1 ?
                        1 : (statusObj?.model?.id || 5) === 2 ?
                            5 : (statusObj?.model?.id || 5) === 3 ?
                                3 : (statusObj?.model?.id || 5) === 4 ?
                                    0 : (statusObj?.model?.id || 5) === 5 ?
                                        -1 : (statusObj?.model?.id || 5) === 6 ?
                                            2 : (statusObj?.model?.id || 5),
                    value: labels?.[statusObj?.label]?.[languageObj?.id] || 'undefined',
                });
                //#endregion variables

                //#region set data
                brdFieldViews.status.label = statusObj?.label;
                brdFieldViews.status.badget = statusObj?.badget;
                brdFieldViews.scheduledDate.date =
                    setDateTimeFormatGlobalString({
                        date: backupReviewDetailData?.scheduledDate,
                        dateFormat: languageObj?.format?.date?.f1,
                        timeFormat: 0,
                        withSeconds: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                brdFieldViews.scheduledDate.time =
                    setDateTimeFormatGlobalString({
                        date: backupReviewDetailData?.scheduledDate,
                        dateFormat: '',
                        timeFormat: languageObj?.format?.time?.type,
                        withSeconds: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                brdFieldViews.executionDate.date =
                    setDateTimeFormatGlobalString({
                        date: backupReviewDetailData?.executionDate,
                        dateFormat: languageObj?.format?.date?.f1,
                        timeFormat: 0,
                        withSeconds: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                brdFieldViews.executionDate.time =
                    setDateTimeFormatGlobalString({
                        date: backupReviewDetailData?.executionDate,
                        dateFormat: '',
                        timeFormat: languageObj?.format?.time?.type,
                        withSeconds: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                brdFieldViews.commentary = backupReviewDetailData?.commentary;
                //#endregion set data
            }
            //#endregion backupreviewdetail (set fieldviews)

            //#region set data
            setModalObj(prev => ({
                ...prev,
                dtBackupReviewDetailsRowId: rowId,
                backupReview: backupReview,
                backupReviewDetail: backupReviewDetailData,
                brdFieldViews: brdFieldViews,
                showModal: true,
                status: statusData,
                type: type,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteBackupReviewDetail = async ({
        e = {},
        _id = '',
        description = '',
        rowId = 0,
        subMethod = '', } = {}
    ) => {
        const currentMethod = 'deleteBackupReviewDetail';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: messages?.areYouShureDeleteThis?.[languageObj?.id],
                two: `${labels?.detail?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id],
            }
            let swalProperties = new SwalPropertiesClass().getClass();
            swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        });

                        //#region delete data (backupreviewdetail)
                        preConfirmResponse = await BackupReviewService.deleteDetail({
                            auth,
                            id: _id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (backupreviewdetail)

                        //#region delete datatable (backupreviewdetail)
                        $(`#${dtBackupReviewDetailsId}`)?.DataTable().row(rowId).remove()?.draw(true);
                        //#endregion delete datatable (backupreviewdetail)

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`
                        });
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion backupreviewdetails

    //#region service documents
    const getServiceDocumentEditDetail = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        type = 2,
        subMethod = '', } = {}
    ) => {
        const currentMethod = 'getServiceDocumentEditDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setDataInfo({ id: id, description: description, rowId: rowId, type: type, });
            btnSdDetailRef?.current?.click();
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const showServiceDocumentDetail = async ({
        e = {},
        subMethod = '', } = {}
    ) => {
        const currentMethod = 'showServiceDocumentDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, serviceDocumentDetail: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            //#region set data
            setModalObj(prev => ({
                ...prev,
                serviceDocument: serviceDocuments?.filter(({ type, number }) => type === dataInfo?.description && number === dataInfo?.id)[0] || {},
                dtServiceDocumentsRowId: dataInfo?.rowId,
                type: dataInfo?.type,
                sdShowModal: true,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, serviceDocumentDetail: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion service documents

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region variables
            let statusData = [Status?.getClass({}, false)];
            let customerData = Customer?.getClass({}, false);
            let customersData = [Customer?.getClass({}, false)];
            let backupReviewData = BackupReview?.getClass({}, false);
            let serviceDocumentsData = [DigitizedDocument?.getClass({}, false)];
            let digitizedDocumentsData = [DigitizedDocument?.getClass({}, false)];
            let backupReviewDetailsData = [BackupReviewDetail?.getClass({}, false)];
            //#endregion variables

            //#region check type (url)
            if (viewType !== 1 && viewType !== 2) {
                window.location.href = urls?.notFound;
            }
            //#endregion check type (url)

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region check role
                if (viewType === 1 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                    response = getResponse({
                        type: 1,
                        msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`,
                        urlGoTo: urls?.back,
                    });
                    return;
                }
                //#endregion check role

                //#region check data
                if (isUndNullEmp({ data: id, subMethod: currentMethod })?.result) {
                    response = getResponse({
                        type: 1,
                        msgText: `${labels?.customer?.[languageObj?.id]}. ${messages?.itIsRequired[languageObj?.id]}.`,
                        urlGoTo: urls?.back
                    });
                    return;
                }
                //#endregion check data

                //#region get data (backupreview)
                response = await BackupReviewService.getByCustomerSecondaryIdAsync({
                    auth,
                    id,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return

                //#region set data
                customersData = response?.result?.customers?.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
                setCustomers(customersData);
                customerData = response?.result?.customer || {};

                setCustomer(customerData);
                backupReviewData = response?.result?.backupReview || {};
                if (backupReviewData?.id <= 0) {
                    const dateTimeFormat = `${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f1}`;//'YYYY-MM-DDTHH:mm';
                    const today = new Date()?.toISOString();
                    backupReviewData.dateBegin = moment(today).format(dateTimeFormat);
                }
                setBackupReview(backupReviewData);
                setBackupReviewBefore(backupReviewData);
                backupReviewDetailsData = response?.result?.backupReviewDetails || [];
                statusData = response?.result?.status || [];
                setStatus(statusData);
                digitizedDocumentsData = response?.result?.digitizedDocuments || [];
                serviceDocumentsData = response?.result?.serviceDocuments || [];
                setServiceDocuments(serviceDocumentsData);
                //#endregion set data

                //#region check data
                if (isUndNullEmp({ data: customerData, subMethod: currentMethod })?.result) {
                    response = getResponse({
                        type: 1,
                        msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}.<br/>`
                    });
                    return;
                }
                //#endregion check data
                //#endregion get data (backupreview)

                //#region field views (set)
                if (viewType === 2) {
                    response = setFieldViews({
                        _backupReview: backupReviewData,
                        _customers: customersData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion field views (set)

                //#region set data input timers
                response = setDateInControl({
                    _date: new Date().toISOString(),
                    _dateBegin: backupReviewData?.dateBegin,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return
                //#endregion set data input timers

                //#region set datatable
                if ((!isUndNullEmp({ data: backupReviewDetailsData, subMethod: currentMethod })?.result && backupReviewDetailsData.length > 0) ||
                    (!isUndNullEmp({ data: digitizedDocumentsData, subMethod: currentMethod })?.result && digitizedDocumentsData.length > 0)) {
                    response = setDataInDataTable({
                        data: backupReviewDetailsData,
                        digitizedDocuments: digitizedDocumentsData,
                        serviceDocuments: serviceDocumentsData,
                        status: statusData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
                window.location.href = urls?.back;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const goToBack = async ({
        subMethod = '' } = {}
    ) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = urls?.back;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, back: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const goToEdit = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToEdit';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, edit: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = `${urls?.edit}${customer?.secundaryId || ''}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, edit: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setFieldViews = ({
        _backupReview = {},
        _customers = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFieldViews';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let _fieldsViewObj = {
                backupReview: {
                    ...rFieldsViewObj?.backupReview,
                },
            };
            //#endregion variables

            if (!isUndNullEmp({ data: _backupReview, subMethod: currentMethod })?.result &&
                _backupReview?.id > 0) {
                //#region variables
                const modelBackupReview = BackupReview?.getClass(_backupReview, false);
                const modelCustomer = Customer?.getClass(_customers?.filter((customer) => customer.id === modelBackupReview?.customerId)[0] || {}, false);
                //#endregion variables

                _fieldsViewObj.backupReview.commentary = modelBackupReview?.commentary || '';
                _fieldsViewObj.backupReview.customer = `${modelCustomer?.rif || ''} - ${modelCustomer?.name || ''}`;

                //#region datebegin
                response = setDateTimeFormatGlobalString({
                    date: modelBackupReview?.dateBegin,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: 0,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return response;
                _fieldsViewObj.backupReview.dateBegin = response?.result;
                //#endregion datebegin

                _fieldsViewObj.backupReview.id = modelBackupReview?.id || 0;
                _fieldsViewObj.backupReview.isActive = modelBackupReview?.isActive;

                //#region register
                response = setDateTimeFormatGlobalString({
                    date: modelBackupReview?.register || new Date().toISOString(),
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: languageObj?.format?.time?.type,
                    withSeconds: 0,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return response;
                _fieldsViewObj.backupReview.register = response?.result;
                //#endregion register

                setRFieldsView(prev => ({
                    ...prev,
                    ..._fieldsViewObj,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region digitized documents (info documents)
            $(`#${dtInformationDocumentsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.row[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.type?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.document?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.description?.[languageObj?.id], width: '65%', orderable: false, },
                    { title: labels?.file[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                //order: [[0, 'desc'],],
                responsive: true,
                lengthChange: false,
                autoWidth: false,
                info: false,
                ordering: false,
                paging: false,
                searching: false,
            });
            //.buttons().container().appendTo(`#${dtBackupReviewDetailsId}_wrapper .col-md-6:eq(0)`);
            //#endregion digitized documents (info documents)

            //#region digitized documents (service documents)
            $(`#${dtServiceDocumentsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'dateTime', width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.row[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.type?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.document?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.date?.[languageObj?.id], width: '10%', orderable: false, },
                    {
                        title: labels?.daysToExpire?.[languageObj?.id], className: 'text-center', width: '15%', orderable: false,
                        render: function (data, type, row) {
                            try {
                                let newData = '';
                                const remainingDays = parseInt(data);
                                if (remainingDays >= 15) {
                                    newData = `<span class='text-success'>${data}</span>`;
                                } else if (remainingDays < 15 && remainingDays >= 1) {
                                    newData = `<span class='text-warning'>${data}</span>`;
                                } else {
                                    newData = `<span class='text-danger'>${data}</span>`;
                                }
                                return newData;
                            } catch (ex) {
                                return ex?.message;
                            }
                        },
                    },
                    { title: labels?.commentary?.[languageObj?.id], width: '35%', orderable: false, },
                    { title: labels?.file[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                order: [[0, 'asc'],],
                //ordering: false,
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtServiceDocumentsId}_wrapper .col-md-6:eq(0)`);
            //#endregion digitized documents (service documents)

            //#region backup reviews
            $(`#${dtBackupReviewDetailsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'dateTime', width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.scheduledDate?.[languageObj?.id], width: '15%', orderable: false, },
                    { title: labels?.executionDate?.[languageObj?.id], width: '15%', orderable: false, },
                    { title: labels?.status?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.observation?.[languageObj?.id], width: '55%', orderable: false, },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtBackupReviewDetailsId}_wrapper .col-md-6:eq(0)`);
            //#endregion backup reviews
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id_ = '';
            //let attr = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            //#region service documents
            $(`#${dtServiceDocumentsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtServiceDocumentsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'details':
                            getServiceDocumentEditDetail({ e: e, id: parseInt(id_), description: description, rowId: rowId, type: 2, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion service documents

            //#region backup review details
            $(`#${dtBackupReviewDetailsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtBackupReviewDetailsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getEditBackupReviewDetail({ e: e, id: id_, description: description, rowId: rowId, type: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            getEditBackupReviewDetail({ e: e, id: id_, description: description, rowId: rowId, type: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            deleteBackupReviewDetail({ e: e, _id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion backup review details
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        digitizedDocuments = [],
        serviceDocuments = [],
        status = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowData = [];
            let dateTime = '';
            let emisionDate = '';
            let urlDocument = '';
            let remainingDays = 0;
            let processButtons = [];
            let modelDigitizedDocument = DigitizedDocument?.getClass({}, false);
            //#endregion variables

            //#region process
            //#region digitizeddocumets (info)
            rowData = [];
            digitizedDocuments.forEach((documentInfo) => {
                //#region variables
                modelDigitizedDocument = DigitizedDocument?.getClass(documentInfo, false);
                urlDocument = isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfNoAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/>` :
                    `<a href='${modelDigitizedDocument?.urlDownload}' rel='noreferrer noopener' target='_blank'><img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/></a>`;
                //#endregion variables

                rowData.push([
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.type,
                    modelDigitizedDocument?.numberStr,
                    modelDigitizedDocument?.description,
                    urlDocument,
                ]);
            });

            $(`#${dtInformationDocumentsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion digitizeddocumets (info)

            //#region digitizeddocumets (servicedocuments)
            rowData = [];
            serviceDocuments.forEach((documentService) => {
                //#region variables
                modelDigitizedDocument = DigitizedDocument?.getClass(documentService, false);
                dateTime = modelDigitizedDocument?.emisionDate;
                emisionDate = setDateTimeFormatGlobalString({
                    date: modelDigitizedDocument?.emisionDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                remainingDays = modelDigitizedDocument?.service?.remainingDays;
                urlDocument = isUndNullEmp({ data: modelDigitizedDocument?.urlDownload, subMethod: currentMethod })?.result ?
                    `<img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfNoAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/>` :
                    `<a href='${modelDigitizedDocument?.urlDownload}' rel='noreferrer noopener' target='_blank'><img alt='${modelDigitizedDocument?.rowNumber}' height='30' src='${images?.icons?.pdfAvailableIcon}' title='${modelDigitizedDocument?.description}' width='25'/></a>`;
                processButtons = [];
                //#endregion variables

                rowData.push([
                    dateTime,
                    modelDigitizedDocument?.rowNumber,
                    modelDigitizedDocument?.description,
                    modelDigitizedDocument?.number,
                    emisionDate,
                    remainingDays,
                    modelDigitizedDocument?.item?.description,
                    urlDocument,
                    getProcessButtons({
                        id: modelDigitizedDocument?.number,
                        description: modelDigitizedDocument?.type,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: false,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: false,
                        showEdit: false,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: false,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtServiceDocumentsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion digitizeddocumets (servicedocuments)

            //#region backupreviewdetails
            rowData = [];
            data.forEach((backupReviewDetail) => {
                //#region variables
                const modelBackupReviewDetail = BackupReviewDetail?.getClass(backupReviewDetail, false);
                const statusObj = {
                    badget: '',
                    model: Status?.getClass(status?.filter(({ id }) => id === modelBackupReviewDetail?.statusId)[0] || {}, false),
                    label: '',
                }
                dateTime = modelBackupReviewDetail?.scheduledDate;
                const scheduledDate = setDateTimeFormatGlobalString({
                    date: modelBackupReviewDetail?.scheduledDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const executionDate = setDateTimeFormatGlobalString({
                    date: modelBackupReviewDetail?.executionDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                statusObj.label = !isUndNullEmp({ data: statusObj?.model?.label, subMethod: currentMethod }) ?
                    statusObj?.model?.label :
                    `${statusObj?.model?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${statusObj?.model?.name?.replace(' ', '')?.slice(1)}`;
                statusObj.badget = badgetStatusGeneric({
                    type: (statusObj?.model?.id || 5) === 1 ?
                        1 : (statusObj?.model?.id || 5) === 2 ?
                            5 : (statusObj?.model?.id || 5) === 3 ?
                                3 : (statusObj?.model?.id || 5) === 4 ?
                                    0 : (statusObj?.model?.id || 5) === 5 ?
                                        -1 : (statusObj?.model?.id || 5) === 6 ?
                                            2 : (statusObj?.model?.id || 5),
                    value: labels?.[statusObj?.label]?.[languageObj?.id] || 'undefined',
                });
                const buttonDescription = `${scheduledDate} - ${executionDate} - ${statusObj?.label}`;
                processButtons = [];
                //#endregion variables

                rowData.push([
                    dateTime,
                    scheduledDate,
                    executionDate,
                    statusObj?.badget,
                    modelBackupReviewDetail?.commentary || '',
                    getProcessButtons({
                        id: modelBackupReviewDetail.id,
                        description: buttonDescription,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        showEdit: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtBackupReviewDetailsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion backupreviewdetails
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        _date = undefined,
        _dateBegin = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let dateBegin = '';
            const tf = languageObj?.format?.time?.type;
            const dtf = `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`;
            const df = languageObj?.format?.date?.f1;
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: _dateBegin, subMethod: currentMethod })?.result) {
                dateBegin = setDateTimeFormatGlobalString({ date: _dateBegin, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: _date, subMethod: currentMethod })?.result) {
                dateBegin = setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${controls?.pickers?.dateBegin?.id}`)?.datetimepicker(
                'options',
                {
                    //date: moment(`${dateTime}`, dateTimeFormat, true),
                    //date: moment(dateTime).format(dateTimeFormat),
                    date: dateBegin,
                    default: false,
                    timepicker: true,
                    format: dtf,
                    //format: 'L',
                }
            );
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({
                ...prev,
                customer: '',
                dateBegin: '',
                commentary: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const dateBegin = $(`#${controls?.pickers?.dateBegin?.id}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region methods
            setBackupReview(prev => ({
                ...prev,
                dateBegin: moment(dateBegin).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`),
            }));
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const dateTimeFormat = `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.f1}`;
            const dateBeginObj = moment($(`#${controls?.inputs?.dateBegin?.id}`).val(), dateTimeFormat);
            const dateBegin = dateBeginObj._d;
            //#endregion variables

            //#region method
            if (isUndNullEmp({ data: backupReview, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    customer: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                    dateBegin: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                    commentary: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmp({ data: backupReview?.customerId, subMethod: currentMethod })?.result ||
                parseInt(backupReview?.customerId) <= 0) {
                setErrors(prev => ({
                    ...prev,
                    customer: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmp({ data: dateBegin, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    dateBegin: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                }));
                response = getResponse({ type: 1 });
            } else if (!isUndNullEmp({ data: dateBegin, subMethod: currentMethod })?.result && !isValidDate({ data: dateBegin, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    dateBegin: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmp({ data: backupReview?.commentary, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    commentary: `${messages?.thisFieldRequired?.[languageObj?.id]}.`,
                }));
                response = getResponse({ type: 1 });
            }
            //#endregion method
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={settings?.app?.views?.services?.services}
                process={settings?.app?.views?.backupReviews?.backupReviews} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={`${urls?.back}`}>{labels?.backupReviews?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>
                                        {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Content Header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={settings?.html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.backupReview?.[languageObj?.id]}
                                                            style={{ ...styles?.cardHeaderLogo }}
                                                            src={images?.icons?.backupReviews} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.backupReview?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className={`badge badge-pill px-2 py-1 text-uppercase ${viewType === 1 ? 'badge-warning' : 'badge-secondary'}`}
                                                                style={settings?.html?.badges?.micro}>
                                                                <i className={`${viewType === 1 ? icons?.fasFa?.edit : icons?.fasFa?.eye} mr-1`}></i>
                                                                {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>

                                                {viewType === 1 ? (
                                                    <form onSubmit={(e) => e?.preventDefault()}>
                                                        <div className='row'>
                                                            <div className='col-12 col-md-2'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.fasFa?.hashTag} /> {labels?.number?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.inputs?.number?.id}
                                                                        className='form-control bg-light border-0 shadow-sm text-dark font-weight-bold'
                                                                        style={{ borderRadius: '5px' }}
                                                                        readOnly
                                                                        disabled
                                                                        value={backupReview.id || 0}
                                                                        placeholder={labels?.number?.[languageObj?.id]}
                                                                        title={labels?.number?.[languageObj?.id]} />
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-6'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.fasFa?.user} /> {labels?.customer?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.customers?.id}
                                                                        className='custom-select bg-light border-0 shadow-sm text-dark'
                                                                        style={{ borderRadius: '5px' }}
                                                                        disabled={process?.showLoading}
                                                                        onChange={(e) => setBackupReview(prev => ({ ...prev, customerId: parseInt(e?.target?.value) }))}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, customer: '', }))}
                                                                        value={`${backupReview?.customerId}` || '0'}
                                                                        title={labels?.customer?.[languageObj?.id]}>
                                                                        <option key='0' value='0'>{messages?.selectCustomer?.[languageObj?.id]}</option>
                                                                        {customers?.map((customer) => (
                                                                            <option key={customer?.id} value={customer?.id}>{customer?.name}</option>
                                                                        ))}
                                                                    </select>
                                                                    <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.customer)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group' hidden={!userRoles?.isAdmin}>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.faFa?.calendarAlt} /> {labels?.scheduledDate?.[languageObj?.id]}
                                                                    </small>
                                                                    {!isUndNullEmp({ data: backupReview?.dateBegin, subMethod: controls?.inputs?.dateBegin?.id, })?.result ?
                                                                        <div id={controls?.pickers?.dateBegin?.id} className='input-group date' data-target-input='nearest'>
                                                                            <input id={controls?.inputs?.dateBegin?.id}
                                                                                className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                                                style={{ borderRadius: '5px' }}
                                                                                disabled={process?.showLoading}
                                                                                data-target={`#${controls?.pickers?.dateBegin?.id}`}
                                                                                data-toggle='datetimepicker'
                                                                                onFocus={() => setErrors(prev => ({ ...prev, dateBegin: '' }))}
                                                                                placeholder={labels?.scheduledDate?.[languageObj?.id]}
                                                                                title={labels?.scheduledDate?.[languageObj?.id]}
                                                                                type='text' />
                                                                            <div className='input-group-append' data-target={`#${controls?.pickers?.dateBegin?.id}`} data-toggle='datetimepicker'>
                                                                                <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                                            </div>
                                                                        </div>
                                                                        : <div></div>}
                                                                    <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.dateBegin)}</div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='row'>
                                                            <div className='col-12 col-md-8'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.fasFa?.edit} /> {labels?.observation?.[languageObj?.id]}
                                                                    </small>
                                                                    <textarea id={controls?.textAreas?.commentary?.id}
                                                                        className='form-control bg-light border-0 shadow-sm text-dark'
                                                                        style={{ borderRadius: '5px' }}
                                                                        disabled={process?.showLoading}
                                                                        maxLength={dataFormLength?.max?.commentary}
                                                                        onChange={(e) => setBackupReview(prev => ({ ...prev, commentary: e?.target?.value }))}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                                                        value={!isUndNullEmp({ data: backupReview?.commentary, subMethod: 'commentaryInput' })?.result ? backupReview.commentary : ''}
                                                                        placeholder={labels?.commentary?.[languageObj?.id]}
                                                                        title={labels?.commentary?.[languageObj?.id]}
                                                                        rows={2} />
                                                                    <div className='form-text text-danger mt-1' style={styles?.labelMsgAlert}>{parse(errors?.commentary)}</div>
                                                                </div>
                                                            </div>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.fasFa?.toggleOn} /> {labels?.isActive?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.checkBoxs?.isActive?.id}
                                                                        type='checkbox'
                                                                        disabled={process?.showLoading || viewType !== 1}
                                                                        checked={backupReview?.isActive}
                                                                        style={{ cursor: (process?.showLoading || viewType !== 1) ? 'default' : 'pointer' }}
                                                                        className='shadow-sm'
                                                                        data-toggle='toggle'
                                                                        data-size='xs'
                                                                        data-width={50}
                                                                        data-onstyle='primary'
                                                                        data-on={labels?.yes?.[languageObj?.id]}
                                                                        data-off={labels?.no?.[languageObj?.id]}
                                                                        onClick={(e) => setBackupReview(prev => ({ ...prev, isActive: e?.target?.checked }))}
                                                                        onChange={(e) => setBackupReview(prev => ({ ...prev, isActive: e?.target?.checked }))} />
                                                                    {' '}<label className='control-label' htmlFor={controls?.checkBoxs?.isActive?.id} style={{ cursor: (process?.showLoading || viewType !== 1) ? 'default' : 'pointer' }}>
                                                                        {labels?.enabled?.[languageObj?.id]}?
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                ) : (
                                                    <div className='row'>
                                                        {[
                                                            { label: labels?.number?.[languageObj?.id], value: backupReview?.id || 0, icon: icons?.fasFa?.hashTag, color: 'primary', type: 'number' },
                                                            { label: labels?.customer?.[languageObj?.id], value: parse(rFieldsView?.backupReview?.customer || '---'), icon: icons?.fasFa?.user, color: 'secondary', type: 'text' },
                                                            { label: labels?.beginDate?.[languageObj?.id], value: rFieldsView?.backupReview?.dateBegin || '---', icon: icons?.fasFa?.calendarAlt, color: 'info', type: 'date' },
                                                            { label: labels?.enabled?.[languageObj?.id], value: rFieldsView?.backupReview?.isActive, icon: icons?.fasFa?.toggleOn, color: 'success', type: 'boolean' },
                                                            { label: labels?.commentary?.[languageObj?.id], value: rFieldsView?.backupReview?.commentary || '---', wide: true, icon: icons?.fasFa?.edit, color: 'primary', type: 'text' },
                                                        ].map((field, idx) => {
                                                            if (field?.type !== 'boolean') {
                                                                return (
                                                                    <div key={idx} className={`col-12 col-md-${field.wide ? '12' : '6'} mb-3`}>
                                                                        <div className={`p-3 rounded bg-light border-left border-${field.color || 'primary'} shadow-sm h-100`}
                                                                            style={{ borderLeftWidth: '5px' }}>
                                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                                style={html?.labels?.detailMicro}>
                                                                                {field.icon && <i className={`${field.icon} mr-1`} />} {field.label}
                                                                            </small>
                                                                            <span className='text-dark font-weight-bold'>{field.value}</span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            } else {
                                                                return (
                                                                    <div key={idx} className='col-12 col-md-6 mb-3'>
                                                                        <div className={`p-3 rounded bg-light border-left border-${field?.color} shadow-sm h-100`}
                                                                            style={{ borderLeftWidth: '5px' }}>
                                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                                style={html?.labels?.detailMicro}>
                                                                                {field?.icon && <i className={`${field.icon} mr-1`} />} {field?.label}
                                                                            </small>
                                                                            <div className='mt-2'>
                                                                                <input id={controls?.checkBoxs?.isActive?.id}
                                                                                    readOnly
                                                                                    checked={field?.value}
                                                                                    type='checkbox'
                                                                                    style={{ cursor: 'default' }}
                                                                                    data-toggle='toggle'
                                                                                    data-size='xs'
                                                                                    data-width={50}
                                                                                    data-onstyle='primary'
                                                                                    data-on={labels?.yes?.[languageObj?.id]}
                                                                                    data-off={labels?.no?.[languageObj?.id]} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        })}
                                                        {/* <div className='col-12 col-md-6 mb-3'>
                                                            <div className='p-3 rounded bg-light border-left border-secondary shadow-sm h-100'
                                                                style={{ borderLeftWidth: '5px' }}>
                                                                <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                    style={html?.labels?.detailMicro}>
                                                                    <i className={`${icons?.fasFa?.toggleOn} mr-1`} /> {labels?.enabled?.[languageObj?.id]}
                                                                </small>
                                                                <div className='mt-2'>
                                                                    <input id={controls?.checkBoxs?.isActive?.id}
                                                                        readOnly
                                                                        checked={backupReview?.isActive}
                                                                        type='checkbox'
                                                                        style={{ cursor: 'default' }}
                                                                        data-toggle='toggle'
                                                                        data-size='xs'
                                                                        data-width={50}
                                                                        data-onstyle='primary'
                                                                        data-on={labels?.yes?.[languageObj?.id]}
                                                                        data-off={labels?.no?.[languageObj?.id]} />
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                )}

                                                {/* Service status bar */}
                                                <div className='d-flex align-items-center flex-wrap my-3 px-1' style={{ gap: '8px' }}>
                                                    <span className='font-weight-bold text-muted mr-2'>{labels?.service?.[languageObj?.id]}:</span>
                                                    <span className={`badge badge-pill ${serviceDocuments?.length > 0 ? 'badge-success' : 'badge-secondary'} px-3 py-1 shadow-sm`} style={{ fontSize: '0.75rem' }}>
                                                        <i className={`${serviceDocuments?.length > 0 ? icons?.fasFa?.checkCircle : icons?.fasFa?.timesCircle} mr-1`}></i>
                                                        {serviceDocuments?.length > 0 ? labels?.active?.[languageObj?.id] : labels?.inactive?.[languageObj?.id] || 'N/A'}
                                                    </span>
                                                    {(backupReview?.id || 0) <= 0 && (
                                                        <span className='ml-2 text-warning'>
                                                            <i className={`${icons?.triangleFasFa} mr-1`} />
                                                            <b>{labels?.backupReview?.[languageObj?.id]}</b> {messages?.hasNotBeenCreatedYet?.[languageObj?.id]?.toLowerCase()}.
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Action buttons */}
                                                <div className='d-flex flex-wrap justify-content-end align-items-center mt-3 mb-2' style={{ gap: '8px' }}>
                                                    <button id={controls?.buttons?.sdDetail?.id}
                                                        className={controls?.buttons?.sdDetail?.defaultClass}
                                                        disabled={process?.showLoading}
                                                        hidden
                                                        style={{ borderRadius: '5px' }} title={labels?.detail?.[languageObj?.id]}
                                                        type='button'
                                                        ref={btnSdDetailRef}
                                                        onClick={(e) => showServiceDocumentDetail({ e, subMethod: e?.currentTarget?.id })}>
                                                        {!process?.serviceDocumentDetail ? (
                                                            <i id={controls?.icons?.sdDetail?.id} className={controls?.icons?.sdDetail?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.sdDetail?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.detail?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.save?.id}
                                                        className={controls?.buttons?.save?.defaultClass}
                                                        disabled={process?.showLoading || viewType !== 1}
                                                        hidden={viewType !== 1}
                                                        style={{ borderRadius: '5px' }}
                                                        onClick={(e) => addEditBackupReview({ e, subMethod: controls?.buttons?.save?.id })}
                                                        title={labels?.save?.[languageObj?.id]}
                                                        type='button'>
                                                        {!process?.save ? (
                                                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.save?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.save?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.delete?.id}
                                                        className={controls?.buttons?.delete?.defaultClass}
                                                        disabled={process?.showLoading || viewType !== 1 || backupReview?.id <= 0}
                                                        hidden={viewType !== 1}
                                                        style={{ borderRadius: '5px' }}
                                                        onClick={(e) => deleteBackupReview({ e, id: backupReview?.id || 0, description: `${labels?.backupReview?.[languageObj?.id]}: ${backupReview?.id || 0}`, rowId: 0, subMethod: controls?.buttons?.delete?.id })}
                                                        title={labels?.delete?.[languageObj?.id]}
                                                        type='button'>
                                                        <i id={controls?.icons?.delete?.id}
                                                            className={controls?.icons?.delete?.defaultClass} /> {labels?.delete?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.addDetail?.id}
                                                        className={controls?.buttons?.addDetail?.defaultClass}
                                                        disabled={process?.showLoading || viewType !== 1 || (backupReview?.id || 0) <= 0}
                                                        hidden={viewType !== 1} style={{ borderRadius: '5px' }}
                                                        onClick={(e) => getAddBackupReviewDetail({ e, subMethod: e?.currentTarget?.id })}
                                                        title={labels?.addDetail?.[languageObj?.id]}
                                                        type='button'>
                                                        {!process?.addDetails ? (
                                                            <i id={controls?.icons?.addDetail?.id} className={controls?.icons?.addDetail?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.addDetail?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.addDetail?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.edit?.id}
                                                        className={controls?.buttons?.edit?.defaultClass}
                                                        disabled={process?.showLoading || viewType !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst)}
                                                        hidden={viewType !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst)} style={{ borderRadius: '5px' }}
                                                        onClick={(e) => goToEdit({ e, subMethod: controls?.buttons?.edit?.id })}
                                                        title={labels?.edit?.[languageObj?.id]}
                                                        type='button'>
                                                        {!process?.edit ? (
                                                            <i id={controls?.icons?.edit?.id} className={controls?.icons?.edit?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.edit?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.edit?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.report?.id}
                                                        className={controls?.buttons?.report?.defaultClass}
                                                        disabled={process?.showLoading || viewType !== 2 || backupReview?.id <= 0}
                                                        hidden={viewType !== 2} style={{ borderRadius: '5px' }}
                                                        onClick={(e) => getBackupReviewReport({ e, subMethod: e?.currentTarget?.id })}
                                                        title={labels?.report?.[languageObj?.id]}
                                                        type='button'>
                                                        {!process?.report ? (
                                                            <i id={controls?.icons?.report?.id} className={controls?.icons?.report?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.report?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.report?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.defaultClass}
                                                        disabled={process?.showLoading}
                                                        style={{ borderRadius: '5px' }}
                                                        title={labels?.back?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={() => goToBack({ subMethod: controls?.buttons?.back?.id })}>
                                                        {!process?.back ? (
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.back?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.back?.[languageObj?.id]}
                                                    </button>
                                                </div>

                                                {/* Section: Information Documents */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.fileAlt} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.informationDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtInformationDocumentsId} languageObj={languageObj} />

                                                {/* Section: Service Documents */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.folderOpen} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.serviceDocuments?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtServiceDocumentsId} languageObj={languageObj} />

                                                {/* Section: Backup Reviews */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.dataBase} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.backupReviews?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtBackupReviewDetailsId} languageObj={languageObj} />

                                            </div>{/* /.card-body */}
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>
            </div>

            {modalObj?.showModal && (
                <BackupReviewDetailAddEditDetail modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
            {modalObj?.reportShowModal && (
                <BackupReviewReport modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
            {modalObj?.sdShowModal && (
                <ServiceDocumentDetail modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
        </div>
    )
}